import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const DataTypePassionPillWrapper = styled.div`
  width: fit-content;
  display: inline;
  padding: 2px 6px;
  background: rgba(251, 175, 161, 0.2);
  border-radius: 8px;

  transition: background 200ms ease-in-out;
  &:hover {
    background: rgba(251, 175, 161, 0.4);
  }

  & > :not(:last-child) {
    margin-right: 4px;
  }

  ${BREAKPOINTS.tablet} {
    padding: 2px 6px;
  }

  cursor: pointer;
  -webkit-box-decoration-break: clone;
  position: relative;
`;

export const DataTypePassionIconContainer = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transform: translateY(2px);
`;

export const DataTypePassionPillText = styled.span`
  font-weight: 400;
  font-size: inherit;
  line-height: 35px;

  color: var(--color-text);
`;
